export const FEATURE_FLAGS = {
  /** Display user's fiat currency instead of HPR */
  DISPLAY_USER_CURRENCY: "display_user_currency",
} as const;
